import React, { useEffect, useState } from 'react';
import { getWorldpayCheckoutConfig, WorldpayCheckoutConfig } from '../api/worldpayCheckout';
import { WorldpayPaymentPanel } from './WorldpayPaymentPanel';
import { WorldpayCheckoutPanel, WorldpayPanelProps } from './WorldpayCheckoutPanel';

export function WorldpayPhonePaymentPanel(props: WorldpayPanelProps) {
  const [config, setConfig] = useState<WorldpayCheckoutConfig | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    getWorldpayCheckoutConfig().then(value => {
      if (!cancelled) setConfig(value);
    }).catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, []);
  if (failed) return <div className="void-modal-content worldpay-panel"><p role="alert">Worldpay payment configuration could not be loaded. Close and reopen this window to retry.</p><button type="button" onClick={props.onClose}>Close</button></div>;
  if (!config) return <div className="void-modal-content worldpay-panel" role="status">Loading Worldpay…</div>;
  return config.enabled ? <WorldpayCheckoutPanel key={props.payment.id} {...props} config={config} /> : <WorldpayPaymentPanel {...props} />;
}
